/* compare-add-first.js (Horizon-safe) */
(() => {
  'use strict';

  // IMPORTANT: Must match compare page STORAGE_KEY (your compare-products.js)
  // If your compare script uses v2:
  const STORAGE_KEY = 'cmp:compare-products:v2';

  function safeParse(str, fallback) {
    try { return JSON.parse(str); } catch { return fallback; }
  }

  function uniq(arr) {
    return Array.from(new Set((arr || []).filter(Boolean)));
  }

  function save(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ handles: uniq(handles) }));
  }

  function load() {
    const raw = localStorage.getItem(STORAGE_KEY);
    const obj = safeParse(raw, { handles: [] });
    return uniq(obj.handles || []);
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cmp-add-first]');
    if (!btn) return;

    const handle = btn.getAttribute('data-handle');
    const compareUrl = btn.getAttribute('data-compare-url') || '/pages/compare-products';
    if (!handle) return;

    const existing = load().filter(h => h !== handle);

    // Add as 1st product
    const next = [handle, ...existing];

    save(next);

    // Redirect with share-friendly URL
    const url = new URL(compareUrl, location.origin);
    url.searchParams.set('items', next.join(','));
    location.href = url.toString();
  });
})();
